export const iconFontAwesomeWeatherBolt = (
	<i className="fa-solid fa-bolt"></i>
);
